import React from 'react';
import './styles/CupSteamLoader.css';

/** Кружка с изогнутым паром, который улетает вверх */
const CupSteamLoader = ({ className = '', size = 'md' }) => (
  <div
    className={`cup-steam cup-steam--${size} ${className}`.trim()}
    aria-hidden="true"
  >
    <div className="cup-steam__vapour">
      <svg className="cup-steam__steam cup-steam__steam--1" viewBox="0 0 20 48" fill="none">
        <path
          d="M10 46C10 46 4 36 6 28C8 20 14 18 12 10C10 4 11 1 11 1"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
        />
      </svg>
      <svg className="cup-steam__steam cup-steam__steam--2" viewBox="0 0 20 48" fill="none">
        <path
          d="M10 46C10 46 14 38 12 30C10 22 5 20 8 12C10 6 10 1 10 1"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
        />
      </svg>
      <svg className="cup-steam__steam cup-steam__steam--3" viewBox="0 0 20 48" fill="none">
        <path
          d="M10 46C10 46 6 37 8 29C10 21 15 19 13 11C11 5 12 1 12 1"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
        />
      </svg>
    </div>

    <div className="cup-steam__cup">
      <span className="cup-steam__rim" />
      <span className="cup-steam__body" />
      <span className="cup-steam__handle" />
      <span className="cup-steam__saucer" />
    </div>
  </div>
);

export default CupSteamLoader;
